import { brokersService } from '@/services';
import type { GetBrokerUsersParams } from '@/services/brokers/types';
import { useQuery } from '@tanstack/react-query';

export function useBrokersUsers(
  brokerId: string | undefined,
  params?: GetBrokerUsersParams
) {
  return useQuery({
    queryKey: ['brokers-users', brokerId, params],
    queryFn: async () => {
      if (!brokerId) throw new Error('ID do corretor não informado');

      const response = await brokersService.getBrokerUsers(brokerId, params);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar usuários do corretor'
        );
      }

      return response.data;
    },
    enabled: Boolean(brokerId),
    staleTime: 1000 * 60 * 5,
  });
}
